<template>
  <div class="c-tabber">
    <div
      data-cy="tab"
      v-for="tab in tabs"
      :key="tab.value"
      :ref="tab.value"
      :class="getClasses(tab)"
      @click="$emit('change-tab', tab.value)"
    >
      <k-icon
        v-if="tab.icon"
        class="icon"
        :icon="tab.icon"
        size="20"
      />

      <span
        :data-cy="`ctabber-${tab.name}`"
        class="text"
      >{{ tab.name }}</span>
    </div>
  </div>
</template>

<script>
import { KIcon } from '@/components/KaledoComponents'
export default {
  components: {
    KIcon
  },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeTab: String
  },
  methods: {
    getClasses (tab) {
      const classes = ['tab', {
        '-active': tab.value === this.activeTab,
        '-icon': tab.icon
      }]
      return classes
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.c-tabber {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  border-bottom: 1px solid $border-color;
  background: white;

  & > .tab {
    padding: 30px 5px 15px;
    text-transform: uppercase;
    color: $text-color;
    line-height: 1;
    text-align: center;
    font-weight: 600;
    font-size: 14px;
    transition: color .3s ease;
    cursor: pointer;
    flex-grow: 1;

    &.-active {
      color: $primary-color-placeholder;
      color: var(--color-primary);
      border-bottom: 3px solid $secondary-color-placeholder;
      transition: .3s ease,
    }

    &.-icon {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;

      @include mobile {
        font-size: 10px;
        color: $base-color;
        font-weight: 400;
      }

      & > .icon { margin-bottom: 10px; }
      @include mobile {
        & > .text {
          display: flex;
          align-items: center;
          height: 20px;
          padding-left: 5px;
          padding-right: 5px;
          line-height: 10px;
          font-size: 8px;
          font-weight: 700;
          text-align: center;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CTabber.vue